import { BaseAction } from '../action'
export class EuGridAction extends BaseAction {

    constructor(options: BaseAction) {
        super(options)
    }
}